// 2019-9-1 赵祥悦 移动头像和语言切换至左侧菜单区
<template>
  <div class="leftNav">
    <el-scrollbar style="height: 100%">
      <div class="navTitle">
        <div class="factoryTitle">
          <div class="logo"><img :src="factoryLogoSrc" /></div>
          <p v-show="!$store.state.isCollapse">{{ factoryTitle }}</p>
        </div>
        <LeftIcon
          title=""
          v-if="!$store.state.isCollapse"
          @click.native="switchBtn('2')"
          class="foldIcon"
        />
        <RightIcon
          v-else
          @click.native="switchBtn('1')"
          title=""
          class="foldIcon"
        />
      </div>
      <!-- 移动头像和语言切换至左侧菜单区 -->
      <div class="info">
        <el-dropdown class="dropdown" placement="right-start">
          <span class="el-dropdown-link">
            <canvas class="headerAvatar" width="40" height="40"></canvas>
          </span>
          <el-dropdown-menu
            slot="dropdown"
            class="dropdown-menu-right"
            v-if="!$store.state.isCollapse"
          >
            <el-dropdown-item
              ><router-link class="hyperlink" to="/account">{{
                $t('allTitle.accountBtn')
              }}</router-link></el-dropdown-item
            >
            <!-- <el-dropdown-item ><p @click="getAllTenants()">{{$t('allTitle.switchBtn')}}</p></el-dropdown-item> -->
            <el-dropdown-item
              ><p @click="loginOut()">
                {{ $t('allTitle.outBtn') }}
              </p></el-dropdown-item
            >
          </el-dropdown-menu>
          <el-dropdown-menu slot="dropdown" class="dropdown-menu-left" v-else>
            <el-dropdown-item
              ><router-link class="hyperlink" to="/account">{{
                $t('allTitle.accountBtn')
              }}</router-link></el-dropdown-item
            >
            <!-- <el-dropdown-item ><p @click="getAllTenants()">{{$t('allTitle.switchBtn')}}</p></el-dropdown-item> -->
            <el-dropdown-item
              ><p @click="loginOut()">
                {{ $t('allTitle.outBtn') }}
              </p></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
        <p class="langChage">
          <span
            @click="langChage(1)"
            :class="{ selected: $store.state.lang === 1 }"
            >中</span
          >
          /
          <span
            :class="{ selected: $store.state.lang === 0 }"
            @click="langChage(0)"
            >EN</span
          >
        </p>
      </div>
      <!-- 导航 -->
      <el-menu
        :default-active="msg"
        :router="true"
        class="el-menu-vertical"
        :collapse="$store.state.isCollapse"
        background-color="#E7EBF1"
        text-color="#525f7f"
        active-text-color="#6772e5"
      >
        <!-- 主页 -->
        <el-menu-item
          index="/"
          v-show="authority.WorkShopDashBoard.show && MenuShow"
        >
          <EarthIcon title="" class="navIcon" />
          <span slot="title">{{ $t('leftNav.navOne') }}</span>
        </el-menu-item>
        <!-- 海安巨胎工厂新增巨胎成型机数字孪生 -->
        <el-menu-item
          v-show="authority.GiantEmbryoMachineDigitalTwin.show && MenuShow"
          v-if="Number($store.state.defaultFactoryId) === 23"
        >
          <a class="ahref" href="http://3d.tst-cloud.com/" target="_blank">
            <Video3d title="" class="navIcon" />
            <span slot="title">{{ $t('leftNav.nav39') }}</span>
          </a>
        </el-menu-item>
        <!-- 车间仪表板 -->
        <!-- <el-menu-item v-show="authority.WorkShopDashBoard.show" :index="`/DB/W/${$store.state.defaultShopId}`">
          <TVIcon title="" class="navIcon"/>
          <span slot="title">{{$t("leftNav.navnineteen")}}</span>
        </el-menu-item> -->
        <!-- 设备仪表板 -->
        <el-menu-item
          @click="pagereload"
          v-show="authority.EquipmentDashboard.show && MenuShow"
          :index="`/EquipmentDashBoard/${$store.state.defaultId}`"
        >
          <macDashboardIcon title="" class="navIcon" />
          <span slot="title">{{ $t('leftNav.navThree') }}</span>
        </el-menu-item>
        <!-- 产量分析 -->
        <el-menu-item
          index="/EP001"
          v-show="authority.ProductionAnalysis.show && MenuShow"
        >
          <appsIcon title="" class="navIcon" />
          <span slot="title">{{ $t('leftNav.navTen') }}</span>
        </el-menu-item>

        <!-- <el-submenu index="13" v-show="authority.ProductionAnalysis.show">
          <template slot="title">
            <appsIcon title="" class="navIcon"/>
            <span slot="title">{{$t("leftNav.navTen")}}</span>
          </template>
          <el-menu-item-group> -->
        <!-- 日产量分析 -->
        <!-- <el-menu-item v-show="authority.DailyProductionAnalysis.show && MenuShow" index="/EP001">{{$t('leftNav.nav26')}}</el-menu-item> -->
        <!-- 周产量分析 -->
        <!-- <el-menu-item v-show="authority.WeeklyProductionAnalysis.show && MenuShow" index="/EP002">{{$t('leftNav.nav27')}}</el-menu-item> -->
        <!-- 月产量分析 -->
        <!-- <el-menu-item v-show="authority.MonthlyProductionAnalysis.show && MenuShow" index="/EP003">{{$t('leftNav.nav28')}}</el-menu-item>
          </el-menu-item-group>
        </el-submenu> -->
        <!-- 设备步序分析 -->
        <el-menu-item
          index="/ES001"
          v-show="authority.EquipmentStepAnalysis.show && MenuShow"
        >
          <areasplineIcon title="" class="navIcon" />
          <span slot="title">{{ $t('leftNav.navFour') }}</span>
        </el-menu-item>
        <!-- 轮胎信息-根据判断显示轮胎信息组 -->
        <!-- 需求【ID1001043】【半制品质量数据跟踪】页面从实验室 发布至 主功能菜单 （仅限中策建德工厂） -->
        <el-submenu
          index="15"
          v-show="authority.TireInformation.show && MenuShow"
          v-if="
            Number($store.state.defaultFactoryId) === 2 ||
            Number($store.state.defaultFactoryId) === 13
          "
        >
          <template slot="title">
            <!-- <CogsIcon title="" class="navIcon"/> -->
            <img
              src="@/assets/img/info.png"
              alt=""
              style="width: 1.3em; height: 1.3em; margin-right: 5px"
            />
            <span slot="title">{{ $t('leftNav.nav32') }}</span>
          </template>
          <el-menu-item-group>
            <!-- 单胎步序分析v2 -->
            <el-menu-item
              v-show="authority.EventGanttV2.show && MenuShow"
              index="/TS001_V2"
            >
              <albumIcon title="" class="navIcon" />
              <span slot="title">{{ $t('pageTitle.TireStep2') }}</span>
            </el-menu-item>
            <!-- 半制品质量数据跟踪 -->

            <el-menu-item
              v-show="authority.SemiProductQualityTrack.show && MenuShow"
              index="/PQ001"
            >
              <trackIcon title="" class="navIcon" />
              <span slot="title">{{ $t('leftNav.nav34') }}</span>
            </el-menu-item>
            <!-- 半制品质量数据报表 -->
            <el-menu-item
              v-show="authority.ireSemiProductQuality.show && MenuShow"
              index="/SC001"
            >
              <reportIcon title="" class="navIcon" />
              <span slot="title">{{ $t('leftNav.nav29') }}</span>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <!-- 单胎步序分析，或只显示单胎步序 (如果是建德工厂显示 甘特V2 为单胎步序)-->
        <el-menu-item
          index="/TS001"
          v-show="authority.SingleTireStepAnalysis.show && MenuShow"
          v-if="
            Number($store.state.defaultFactoryId) !== 2 &&
            Number($store.state.defaultFactoryId) !== 13
          "
        >
          <albumIcon title="" class="navIcon" />
          <span slot="title">{{ $t('pageTitle.TireStep1') }}</span>
        </el-menu-item>
        <!-- 单设备换料统计 -->
        <el-menu-item
          index="/ER002"
          v-show="authority.ReloadingAnalysis.show && MenuShow"
        >
          <reloadIcon title="" class="navIcon" />
          <span slot="title">{{ $t('leftNav.navSeventeenth3') }}</span>
        </el-menu-item>
        <!-- 故障报警 -->
        <el-submenu index="11" v-show="authority.FaultAlarm.show && MenuShow">
          <template slot="title">
            <alertIcon title="" class="navIcon" />
            <span slot="title">{{ $t('leftNav.navSeven') }}</span>
          </template>
          <el-menu-item-group>
            <!-- 设备故障报警 -->
            <el-menu-item
              v-if="Number($store.state.defaultFactoryId) !== 9"
              index="/EF001"
              v-show="authority.EquipmentFaultAlarm.show && MenuShow"
            >
              <settingsBoxIcon title="" class="navIcon" />
              <span slot="title">{{ $t('leftNav.navSeven1') }}</span>
            </el-menu-item>
            <!-- 设备故障报警 -->
            <el-menu-item
              v-if="Number($store.state.defaultFactoryId) === 9"
              index="/EF002"
              v-show="authority.EquipmentFaultAlarm.show && MenuShow"
            >
              <settingsBoxIcon title="" class="navIcon" />
              <span slot="title">{{ $t('leftNav.navSeven1') }}</span>
            </el-menu-item>
            <!-- 部件故障报警 -->
            <el-menu-item
              index="/PFA001"
              v-show="authority.PartsFaultAlarm.show && MenuShow"
            >
              <!-- <memoryIcon title="" class="navIcon"/> -->
              <img
                src="@/assets/img/icon.png"
                alt=""
                style="width: 1.3em; height: 1.3em; margin-right: 5px"
              />
              <span slot="title">{{ $t('leftNav.navSeven2') }}</span>
            </el-menu-item>
            <!-- 新增车间故障统计报告 -->
            <el-menu-item
              index="/WFS001"
              v-show="authority.WorkShopFaultsStatistics.show && MenuShow"
            >
              <homeIcon title="" class="navIcon" />
              <span slot="title">{{ $t('leftNav.nav33') }}</span>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <!--事件甘特图-->
        <el-menu-item
          v-show="authority.EventGantt.show && MenuShow"
          index="/EG001"
        >
          <ganttIcon title="" class="navIcon" />
          <span slot="title">{{ $t('leftNav.navNine') }}</span>
        </el-menu-item>
        <!-- 设备综合信息 -->
        <el-submenu
          index="9"
          v-show="authority.EquipmentIntegratedInformation.show && MenuShow"
        >
          <template slot="title">
            <calendarIcon title="" class="navIcon" />
            <span slot="title">{{ $t('leftNav.nav25') }}</span>
          </template>
          <el-menu-item-group>
            <!-- 设备分时信息 -->
            <el-menu-item
              index="/FT001"
              v-show="
                authority.EquipmentTimeSharingInformation.show && MenuShow
              "
              >{{ $t('leftNav.navtwentieth') }}</el-menu-item
            >
            <!-- 节拍时间分布 -->
            <el-menu-item
              v-show="authority.CycleDistribution.show && MenuShow"
              index="/CD001"
              >{{ $t('leftNav.navSeventeenth1') }}</el-menu-item
            >
            <!-- 新增设备规格信息 -->
            <el-menu-item
              index="/SG001"
              v-show="
                authority.EquipmentSpecificationInformation.show && MenuShow
              "
              >{{ $t('leftNav.nav31') }}</el-menu-item
            >
          </el-menu-item-group>
        </el-submenu>
        <!-- 新增工艺参数管理 -->
        <el-submenu
          index="14"
          v-show="authority.ProcessParameterManagement.show && MenuShow"
          v-if="
            Number($store.state.defaultFactoryId) === 2 ||
            Number($store.state.defaultFactoryId) === 17
          "
        >
          <template slot="title">
            <mdiWrench title="" class="navIcon" />
            <span slot="title">{{ $t('leftNav.nav37') }}</span>
          </template>
          <el-menu-item-group>
            <!-- 工艺参数对比 -->
            <el-menu-item
              v-show="
                authority.ComparisonCurrentProcessParameters.show && MenuShow
              "
              index="/CompareCraft"
              >{{ $t('leftNav.navTwentySix') }}</el-menu-item
            >
            <!-- 工艺参数记录 -->
            <el-menu-item
              v-show="authority.ProcessParameterRecord.show && MenuShow"
              index="/RecordCraft"
              >{{ $t('leftNav.navTwentySeven') }}</el-menu-item
            >
            <!-- 偏置参数记录 -->
            <el-menu-item
              v-show="authority.OffsetParameterRecord.show && MenuShow"
              index="/OffsetCraft"
              >{{ $t('leftNav.navTwentyEight') }}</el-menu-item
            >
          </el-menu-item-group>
        </el-submenu>
        <!-- 模拟量数据监控 （原自助仪表板） -->
        <el-menu-item
          v-show="authority.AnalogDataMonitoring.show && MenuShow"
          index="/grafanaAnalog"
        >
          <menuIcon title="" class="navIcon" />
          <!-- <el-menu-item v-show="authority.AnalogData.show">{{$t('leftNav.nav38')}}</el-menu-item> -->
          <span slot="title">{{ $t('leftNav.nav35') }}</span>
        </el-menu-item>
        <!-- 收藏 -->
        <el-submenu index="12" v-show="authority.Favorite.show && MenuShow">
          <template slot="title">
            <starIcon title="" class="navIcon" /><!-- 收藏图标-->
            <span slot="title">{{ $t('leftNav.navEight') }}</span>
          </template>
          <el-menu-item-group class="FavoriteList">
            <el-menu-item
              :index="`/EquipmentDashBoard/${item.id}`"
              @click="pagereload"
              v-for="item in favoriteMachinesList"
              :key="item.id"
              >{{ item.nameEn
              }}<deleteIcon
                style="color: rgb(82, 95, 127)"
                class="deleteFav"
                title=""
                @click.native.stop="deleteBtn(item.id)"
            /></el-menu-item>
          </el-menu-item-group>
        </el-submenu>
        <!-- 新加 实验室 导航 -->
        <el-submenu index="10" v-show="authority.Lab.show && MenuShow">
          <template slot="title">
            <flaskIcon title="" class="navIcon" />
            <span slot="title">{{ $t('leftNav.navSeventeenth') }}</span>
          </template>
          <!-- <el-scrollbar style="height:100%;"> --><!--去掉实验室里的局部导航-->
          <el-menu-item-group class="labMenu">
            <!-- <el-menu-item v-show="$store.state.authority.CycleDistribution.show" index="/CD001">{{$t('leftNav.navSeventeenth1')}}</el-menu-item> -->
            <!-- 换料统计 -->
            <el-menu-item
              v-show="authority.ReloadingStatistics.show && MenuShow"
              index="/ER001"
              >{{ $t('leftNav.navSeventeenth2') }}</el-menu-item
            >
            <!-- 大步序统计报表 -->
            <el-menu-item
              v-show="authority.StepStatisticsReport.show && MenuShow"
              index="/ES003"
              >{{ $t('DetailedStepReport.StepStatisticsReport') }}</el-menu-item
            >
            <!-- 产能预测 -->
            <el-menu-item
              v-show="authority.ProductivityForecast.show && MenuShow"
              index="/PF001"
              >{{ $t('leftNav.navSeventeenth5') }}</el-menu-item
            >
            <!-- 新增-带束位置信息 -->
            <el-menu-item
              v-show="authority.DeviationRectifyingData.show && MenuShow"
              v-if="Number($store.state.defaultFactoryId) === 17"
              index="/BeamPositionInfo"
              >{{ $t('leftNav.navTwentyNine') }}</el-menu-item
            >
            <!-- 模拟量分析 -->
            <el-menu-item
              v-show="authority.AnalogValueAnalysis.show && MenuShow"
              index="/AV001"
              >{{ $t('leftNav.navSeventeenth6') }}</el-menu-item
            >
            <!-- <el-menu-item v-show="$store.state.authority.EventGantt.show" index="/EG001">{{$t('leftNav.navNine')}}</el-menu-item> -->
            <!-- 半制品质量 -->
            <el-menu-item
              v-show="authority.SemiProductQuality.show && MenuShow"
              index="/PQ001"
              >{{ $t('leftNav.nav34') }}</el-menu-item
            >
            <!-- 模拟量图表速览 -->
            <el-menu-item
              v-show="authority.AnalogChartQuickView.show && MenuShow"
              v-if="Number($store.state.defaultFactoryId) === 2"
              index="/AnalogChartQuickView"
              >{{ $t('leftNav.navTwentyOne') }}</el-menu-item
            >
            <!-- 设备稼动率 -->
            <el-menu-item
              v-show="authority.EquipmentUtilizationRate.show && MenuShow"
              index="/EquipmentUtilizationRate"
              >{{ $t('leftNav.navTwentyTwo') }}</el-menu-item
            >
            <!-- 设备详细步序报告 -->
            <el-menu-item
              v-show="authority.EquipmentDetailedStepReport.show && MenuShow"
              index="/ES002"
              >{{ $t('leftNav.navTwentyThree') }}</el-menu-item
            >
            <!-- <el-menu-item index="/Readandwrite">{{$t('leftNav.navTwentyTwo')}}</el-menu-item> -->
            <!-- 设备服务资料下载 -->
            <el-menu-item index="/DeviceServiceDownload"
              >设备服务资料下载
            </el-menu-item>
            <!-- 3d模型 -->
            <el-menu-item
              v-show="authority.ThreeDModel.show && MenuShow"
              v-if="Number($store.state.defaultFactoryId) === 17"
              ><a class="ahref" href="/web3d/" target="_blank">{{
                $t('leftNav.nav20')
              }}</a></el-menu-item
            >
            <!-- 大屏 -->
            <el-menu-item v-show="authority.Platform.show && MenuShow"
              ><a class="ahref" href="/workshopplatform" target="_blank">{{
                $t('leftNav.platform')
              }}</a></el-menu-item
            >
            <!-- 新增granfana链接-自助仪表盘-->
            <!-- <el-menu-item v-show="authority.SelfHelpDashBoard.show"><a class="ahref" href="http://zxy-dashboard.tst-cloud.com/login/generic_oauth" target="_blank">{{$t('leftNav.nav21')}}</a></el-menu-item> -->
            <!-- 查询试数据采集测试工具 -->
            <!-- <el-menu-item index="/DataCollectionTest">查询试数据采集测试工具 </el-menu-item> -->
            <!-- 表单设计器 -->
            <!-- <el-menu-item index="/FormHome">{{$t('fm.formName')}}</el-menu-item> -->
            <!-- 车间报警统计 -->
            <el-menu-item
              v-show="authority.WorkShopAlarmStatistics.show && MenuShow"
              index="/CB001"
              v-if="Number($store.state.defaultFactoryId) === 2"
              >{{ $t('leftNav.nav30') }}</el-menu-item
            >
            <!--新增 导出意见建议-->
            <el-menu-item
              v-show="authority.DownloadSuggestions.show && MenuShow"
              index="/DownloadSuggestions"
              >{{ $t('leftNav.navTwentyFour') }}</el-menu-item
            >
            <!-- 设备平均效率对比 -->
            <el-menu-item
              v-show="authority.AverageCfficiencyComparison.show && MenuShow"
              index="/EquipmentEfficiency"
              v-if="Number($store.state.defaultFactoryId) === 2"
              >{{ $t('leftNav.nav36') }}</el-menu-item
            >
            <!-- 测试grafana打开 -->
            <el-menu-item
              v-show="authority.AnalogDataMonitoring.show && MenuShow"
              ><span slot="title"
                ><a class="ahrefNew" :href="grafanaUrl" target="_blank"
                  >数据监控测试</a
                ></span
              ></el-menu-item
            >
          </el-menu-item-group>
          <!-- </el-scrollbar> -->
        </el-submenu>

        <!-- 新加 VPN盒子 导航 -->
        <el-submenu index="16" v-show="authority.VpnBox.show && !MenuShow">
          <template slot="title">
            <boxIcon title="" class="navIcon" />
            <span slot="title">{{ $t('leftNav.navVpn') }}</span>
          </template>
          <!-- <el-scrollbar style="height:100%;"> --><!--去掉实验室里的局部导航-->
          <el-menu-item-group class="labMenu">
            <!-- VPN申请 -->
            <el-menu-item
              index="/VPN001"
              v-show="authority.VpnBoxApply.show && !MenuShow"
            >
              <!-- <appsIcon title="" class="navIcon"/> -->
              <span slot="title">{{ $t('leftNav.navVpnApply') }}</span>
            </el-menu-item>

            <!-- VPN审核 -->
            <el-menu-item
              index="/VPN002"
              v-show="authority.VpnBoxReview.show && !MenuShow"
            >
              <!-- <appsIcon title="" class="navIcon"/> -->
              <span slot="title">{{ $t('leftNav.navVpnRewiew') }}</span>
            </el-menu-item>

            <!-- VPN添加 -->
            <el-menu-item
              index="/VPN003"
              v-show="authority.VpnBoxManage.show && !MenuShow"
            >
              <!-- <appsIcon title="" class="navIcon"/> -->
              <span slot="title">{{ $t('leftNav.navVpnAdd') }}</span>
            </el-menu-item>

            <!-- 使用说明下载 -->
            <el-menu-item
              v-show="authority.VpnBoxApply.show && !MenuShow"
              @click="downloadInstruction"
            >
              <!-- <appsIcon title="" class="navIcon"/> -->
              <span slot="title">{{ $t('leftNav.navVpnInstructions') }}</span>
            </el-menu-item>

            <!-- VPN软件下载 -->
            <el-menu-item
              v-show="authority.VpnBoxApply.show && !MenuShow"
              @click="downloadVpnzip"
            >
              <!-- <appsIcon title="" class="navIcon"/> -->
              <span slot="title">{{ $t('leftNav.navVpnSoft') }}</span>
            </el-menu-item>
          </el-menu-item-group>
          <!-- </el-scrollbar> -->
        </el-submenu>

        <!--新增 导出意见建议-->
        <!-- <el-menu-item index="/DownloadSuggestions" v-show="authority.DownloadSuggestions.show">
          <albumIcon title="" class="navIcon"/>
          <span slot="title">{{$t("leftNav.navTwentyFour")}}</span>
        </el-menu-item> -->
      </el-menu>
      <!-- 时钟 -->
      <div class="time">
        <!-- 数字倒计时 -->
        <div class="countDown" v-if="!$store.state.isCollapse">{{ time }}</div>
        <!-- 表盘 -->
        <div class="clockwrap" v-show="$store.state.isCollapse">
          <el-tooltip
            class="item"
            effect="dark"
            :content="time"
            placement="right"
          >
            <div class="wrap">
              <div class="sp">
                <div class="number"><span>9</span></div>
                <div class="number"><span>12</span></div>
                <div class="number"><span>3</span></div>
                <div class="number"><span>6</span></div>
              </div>
              <div id="hour" class="shot"></div>
              <div id="min" class="shot"></div>
              <div id="sec" class="shot"></div>
            </div>
          </el-tooltip>
          <br />
        </div>
      </div>
      <div class="footTitle">
        <div class="titleIcon">
          <img src="../assets/img/nav/icon.png" />
        </div>
        <div class="titleText" v-show="!$store.state.isCollapse">
          {{ $t('leftNav.navfoot') }}
        </div>
      </div>
    </el-scrollbar>

    <el-dialog
      :visible.sync="dialogVisible"
      width="700px"
      :title="$t('login.selectfactory')"
      class="selectfactory"
      center
      :close-on-click-modal="false"
    >
      <div class="loginbox">
        <el-scrollbar style="height: 100%">
          <div class="content">
            <div
              class="itembox"
              v-for="(item, index) in factoryList"
              :key="index"
              @click="selectFactoryitem(item)"
              :class="item.tenantCode == selectcode ? 'isActive' : ''"
            >
              <img :src="item.tenantFactoryIcon" alt="" />
              <p v-if="$store.state.lang === 1">{{ item.tenantShortName }}</p>
              <p v-else>{{ item.tenantShortNameEn }}</p>
            </div>
          </div>
        </el-scrollbar>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import EarthIcon from 'vue-material-design-icons/Earth.vue'
import LeftIcon from 'vue-material-design-icons/ChevronLeft.vue'
import RightIcon from 'vue-material-design-icons/ChevronRight.vue'
import RadiotowerIcon from 'vue-material-design-icons/RadioTower.vue'
import domainIcon from 'vue-material-design-icons/Domain.vue'
import pollBoxIcon from 'vue-material-design-icons/PollBox.vue'
import updateIcon from 'vue-material-design-icons/Update.vue'
import playIcon from 'vue-material-design-icons/PlayCircle.vue'
import accountIcon from 'vue-material-design-icons/AccountSupervisor.vue'
import alertIcon from 'vue-material-design-icons/Alert.vue'
import settingsBoxIcon from 'vue-material-design-icons/SettingsBox.vue'
import memoryIcon from 'vue-material-design-icons/Memory.vue'

import starIcon from 'vue-material-design-icons/Star.vue'
import deleteIcon from 'vue-material-design-icons/Delete.vue'
import clearIcon from 'vue-material-design-icons/NotificationClearAll.vue'
import textIcon from 'vue-material-design-icons/ClipboardText.vue'
import albumIcon from 'vue-material-design-icons/Album.vue'
import macDashboardIcon from 'vue-material-design-icons/DesktopMacDashboard.vue'
import analyticIcon from 'vue-material-design-icons/GoogleAnalytics.vue'
import areasplineIcon from 'vue-material-design-icons/ChartAreaspline.vue'
import ganttIcon from 'vue-material-design-icons/ChartGantt.vue'
import flaskIcon from 'vue-material-design-icons/Flask.vue'
import TVIcon from 'vue-material-design-icons/TelevisionGuide.vue'
import reloadIcon from 'vue-material-design-icons/Reload.vue'
import timerIcon from 'vue-material-design-icons/AvTimer.vue'
import calendarIcon from 'vue-material-design-icons/CalendarToday.vue'
import appsIcon from 'vue-material-design-icons/Apps.vue'
import CogsIcon from 'vue-material-design-icons/Cogs.vue'
import homeIcon from 'vue-material-design-icons/HomeVariantOutline.vue'
import trackIcon from 'vue-material-design-icons/Bandcamp.vue'
import reportIcon from 'vue-material-design-icons/FileChart.vue'
import menuIcon from 'vue-material-design-icons/ChartBellCurve.vue'
import mdiWrench from 'vue-material-design-icons/Wrench.vue'
import boxIcon from 'vue-material-design-icons/XingBox.vue'
import Video3d from 'vue-material-design-icons/Video3d.vue'

export default {
  name: 'leftNav',
  components: {
    EarthIcon,
    LeftIcon,
    RightIcon,
    RadiotowerIcon,
    domainIcon,
    pollBoxIcon,
    playIcon,
    updateIcon,
    accountIcon,
    alertIcon,
    settingsBoxIcon,
    memoryIcon,
    starIcon,
    deleteIcon,
    clearIcon,
    textIcon,
    albumIcon,
    macDashboardIcon,
    analyticIcon,
    areasplineIcon,
    ganttIcon,
    flaskIcon,
    TVIcon,
    reloadIcon,
    timerIcon,
    calendarIcon,
    appsIcon,
    CogsIcon,
    homeIcon,
    trackIcon,
    reportIcon,
    menuIcon,
    mdiWrench,
    boxIcon,
    Video3d,
  },
  props: {
    msg: String,
  },
  data() {
    return {
      MenuShow: this.$store.state.newroute !== 'tstmanage',
      time: '',
      timeRun: null,
      favoriteMachinesList: [],
      clockTime: '',
      clockRun: '',
      // 当前时间时间戳
      nowTime: '',
      // 权限列表
      authority: {},
      websock: null,
      dialogVisible: false,
      factoryList: [],
      selectcode: '',
      //dialog去掉关闭按钮
      showClo: false,
      factoryTitle: '', //工厂名称
      factoryLogoSrc: '', //工厂logo路径
      grafanaUrl: '',
    }
  },
  created() {
    if (window.localStorage.getItem('token') === null) {
      this.$router.push({ path: '/login', name: 'login' })
    } else {
      this.authority = JSON.parse(localStorage.getItem('authority'))
    }
  },
  mounted() {
    this.getGrafanaUrl()
    this.getServeTime()
    this.clockTimeRun()
    this.selectFavorite()
    this.touxaing()
    this.getFactoryName()
  },
  destroyed() {
    clearTimeout(this.timeRun)
    clearInterval(this.clockRun)
  },
  methods: {
    // 获取模拟量数据监控跳转的url
    getGrafanaUrl() {
      this.axios.get('/url/getGrafanaUrl').then((res) => {
        this.grafanaUrl = res.data.url
      })
    },
    // 显示工厂名称
    getFactoryName() {
      this.axios
        .get('/url/getCurrentFactoryIcon', {
          params: {
            language: this.$store.state.lang,
            route: this.$store.state.newroute,
          },
        })
        .then((res) => {
          if (res.data.success == true) {
            this.factoryTitle = res.data.tenantShortName
            this.factoryLogoSrc = res.data.tenantFactoryIcon
          }
        })
    },
    // 展开收起侧边栏
    switchBtn(s) {
      this.$store.state.isCollapse = !this.$store.state.isCollapse
      if (s === '1') {
        localStorage.isCollapse = false
      } else {
        localStorage.isCollapse = true
      }
    },
    selectFavorite() {
      let _this = this
      this.axios({
        method: 'POST',
        url: '/url/selectFavoriteMachine',
      }).then(function (res) {
        _this.favoriteMachinesList = res.data.favoriteMachines
      })
    },
    // 时间
    getServeTime() {
      let _this = this
      this.axios({
        method: 'POST',
        url: '/url/getServerTime',
      }).then(function (res) {
        _this.nowTime = res.data
        _this.startTime()
      })
    },
    startTime() {
      let _this = this
      this.timeRun = setInterval(function () {
        var time = new Date(_this.nowTime)
        var y = time.getFullYear()
        var m = time.getMonth() + 1
        var d = time.getDate()
        var h = time.getHours()
        var mm = time.getMinutes()
        var s = time.getSeconds()
        _this.time =
          y +
          '/' +
          m +
          '/' +
          d +
          ' ' +
          h +
          ':' +
          _this.checkTime(mm) +
          ':' +
          _this.checkTime(s)
        _this.nowTime += 1000
      }, 1000)
    },
    checkTime(i) {
      if (i < 10) {
        i = '0' + i
      }
      return i
    },
    // 表盘计时
    clockTimeRun() {
      var sp = document.getElementsByClassName('sp')[0]
      var divNum = sp.getElementsByTagName('div')
      for (var i = 0; i < divNum.length; i++) {
        divNum[i].style.transform = 'rotate(' + i * 90 + 'deg' + ')'
      }
      var nu = sp.getElementsByTagName('span')
      for (var j = 0; j < nu.length; j++) {
        nu[j].style.display = 'inline-block'
        nu[j].style.transform = 'rotate(' + j * -90 + 'deg' + ')'
      }
      let _this = this
      this.clockRun = setInterval(function () {
        var nowDate = new Date(_this.nowTime)
        var h = nowDate.getHours()
        var m = nowDate.getMinutes()
        var s = nowDate.getSeconds()

        //设置时针偏转角度
        var hDeg = (360 / 12) * h
        var hour = document.getElementById('hour')
        hour.style.transform = 'rotate(' + hDeg + 'deg)'

        //设置分针偏转角度
        var mDeg = (360 / 60) * m
        var min = document.getElementById('min')
        min.style.transform = 'rotate(' + mDeg + 'deg)'

        //设置秒针偏转角度
        var sDeg = (360 / 60) * s
        var sec = document.getElementById('sec')
        sec.style.transform = 'rotate(' + sDeg + 'deg)'
      }, 500)
    },
    // 删除收藏
    deleteBtn(machineId) {
      let _this = this
      this.axios({
        method: 'POST',
        url: '/url/deleteFavoriteMachine',
        params: {
          language: _this.$store.state.lang,
          machineId: machineId, // 机器的id
        },
      })
        .then(function (res) {
          _this.$message({
            message: res.data.msg,
            type: 'success',
          })
          _this.selectFavorite()
        })
        .then(function () {
          _this.pagereload()
        })
    },
    pagereload() {
      this.$store.state.isRouterAlive = false
      this.$nextTick(function () {
        this.$store.state.isRouterAlive = true
      })
    },
    // 移动头像和语言切换至左侧菜单区
    // 初始化weosocket
    initWebSocket() {
      let _this = this
      _this.websock = new WebSocket(
        'ws://' +
          _this.$store.state.websocketws +
          _this.$store.state.newroute +
          '/websocket-errorlog'
      )
      // 接收服务器发来的消息
      _this.websock.onmessage = function (e) {
        if (e !== null) {
          var abv = JSON.parse(e.data)

          if (
            JSON.parse(abv['listTopOne']).success === 'true' &&
            JSON.parse(abv['listNine']).success === 'true'
          ) {
            _this.firstLog = JSON.parse(abv['listTopOne']).rows[0]
            _this.behindLog = JSON.parse(abv['listNine']).rows
          }
        }
      }
      // 连接建立之后执行send方法发送数据
      _this.websock.onopen = function () {
        // 向服务器发送消息
        var param = {
          // 'factoryId': _this.$store.state.defaultFactoryId
          accountId: _this.$store.state.accountId,
        }
        var params = JSON.stringify(param)
        _this.websock.send(params)
      }
      // 连接建立失败重连
      _this.websock.onerror = function () {
        _this.websock = new WebSocket(
          'ws://' +
            _this.$store.state.websocketws +
            _this.$store.state.newroute +
            '/websocket-errorlog'
        )
      }
      // 关闭
      _this.websock.onclose = function () {
        _this.websock = null
      }
    },
    // 路由跳转
    jump() {
      // this.$router.push('/EF001')
      if (this.$route.path !== '/EF001') {
        this.$router.push({ path: '/EF001', name: 'FaultAlarmQuery' })
      }
    },
    // 语言切换
    langChage(l) {
      if (l === 1) {
        this.$store.state.lang = 1
        this.$i18n.locale = 'zh'
        localStorage.lang = 1
      } else {
        this.$store.state.lang = 0
        this.$i18n.locale = 'en'
        localStorage.lang = 0
      }
      this.getFactoryName()
    },
    //   登出
    loginOut() {
      let _this = this
      this.axios({
        method: 'post',
        url: '/url/loginOut',
        params: {
          language: _this.$store.state.lang,
        },
      }).then(function (res) {
        if (res.data.success === 'true') {
          _this.$store.commit('loginOut')
          _this.$router.replace({
            path: '/login',
          })
          _this.$message({
            message: res.data.msg,
            type: 'success',
          })
        } else {
          _this.$message.error(res.data.msg)
        }
      })
    },
    // 随机头像
    touxaing() {
      let canvasDiv = document.querySelector('.headerAvatar'),
        usename = localStorage.getItem('userName')
      var strangeHash = function strangeHash(str) {
        var hash = 0
        if (str.length === 0) {
          return hash
        }

        for (var i = 0, len = str.length; i < len; i++) {
          var chr = str.charCodeAt(i)
          hash = (hash << 5) - hash + chr
          hash |= 0
        }

        return (new Array(9).join('1') + Math.abs(hash))
          .slice(-8)
          .replace(/0/g, '1') // Generate string with 8 chars without '0'
      }

      draw(canvasDiv)
      function draw(c) {
        var ctx = c.getContext('2d'),
          h = strangeHash(usename)
        ctx.translate(20, 20)
        ctx.rotate(Math.PI / 4)
        ctx.scale(0.6, 0.6)
        for (var j = 0; j < 8; j++) {
          // Colors (Red, Green, Blue, Alpha) is here.
          var r = (h[0] * 100) % 255,
            // This formula doesn't make sense
            g = (h[j] * 100) % 255,
            // And this too...
            b = (h[8 - j] * 100) % 255,
            // Too many strange ideas in this generator :)
            a = h[j] / 20

          ctx.fillStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')'

          // Coordinates of rectangle. Another strange thing. But result looks fine...
          var c1 = (h[j] * h[j]) % 16,
            c2 = (h[j] * h[7]) % 16,
            c3 = (h[j] * h[0]) % 32,
            c4 = (h[j] * h[0]) % 32

          // Some "normalization"
          if (c1 + c2 < 32) {
            c1 *= -2
            c2 *= -2
            c3 *= 2
            c4 *= 2
          }

          // Some experiments here......
          var s = (h[7] % 2) + 2

          for (var k = 0; k < 2 * s; k++) {
            ctx.fillRect(c1, c2, c3, c4)
            ctx.rotate(Math.PI / s)
          }
        }
      }
    },
    // 获取工厂列表
    getAllTenants() {
      let _this = this
      this.axios({
        method: 'get',
        url: '/url/findTenantsByAccountId',
        params: {
          language: Number(this.$store.state.lang),
          userId: this.$store.state.accountId,
        },
      }).then((res) => {
        if (res.data.success === 'true') {
          _this.factoryList = res.data.TenantInfoList
          _this.selectcode = _this.$store.state.newroute
          _this.dialogVisible = true
        } else {
          _this.$message.error(res.data.msg)
        }
      })
    },
    // 选择工厂+保存
    selectFactoryitem(item) {
      this.selectcode = item.tenantCode
      if (this.selectcode === 'zhongce') {
        window.location.href = 'http://hangzhoupt.tst-cloud.com/login'
      } else {
        localStorage.newroute = item.tenantCode
        this.$store.state.newroute = item.tenantCode
        this.getDefaultMachine()
      }
    },
    getDefaultMachine() {
      let _this = this
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)',
      })
      this.axios({
        method: 'post',
        url: '/url/getDefaultMachine',
      })
        .then((res) => {
          if (res.status === 200) {
            _this.$store.commit('loginId', res.data)
          } else {
            loading.close()
            _this.$message.error(res.data.msg)
          }
        })
        .then(() => {
          window.location.href = '/'
        })
    },
    // 下载使用说明
    downloadInstruction() {
      window.location.href = 'http://www.tst-cloud.com/openvpn/readme.docx'
    },
    // 下载使用说明
    downloadVpnzip() {
      window.location.href =
        'http://www.tst-cloud.com/openvpn/openvpn3client.zip'
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.leftNav {
  height: 100%;
}
.navTitle {
  margin: 15px 0px 0 10px;
}
.navTitle p {
  width: 189px;
}
.footTitle {
  text-align: center;
  width: 100%;
}
.titleIcon {
  width: 31px;
  height: 31px;
  border-radius: 50%;
  background-color: #fff;
  display: inline-block;
  vertical-align: middle;
  margin-top: 10px;
}
.titleIcon img {
  width: 25px;
  margin-left: 3px;
  margin-top: 6px;
}
.titleText {
  color: #525f7f;
  display: inline-block;
  vertical-align: middle;
  font-weight: bold;
  margin-left: 5px;
  margin-top: 10px;
  font-size: 13px;
}
.navTitle .factoryTitle .logo {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background-color: #fff;
  display: inline-block;
  line-height: 35px;
  text-align: center;
}
.navTitle .factoryTitle .logo img {
  width: 35px;
  height: auto;
  vertical-align: middle;
}
.navTitle .factoryTitle p {
  color: #525f7f;
  font-size: 16px;
  display: inline;
  vertical-align: middle;
  font-weight: bold;
  margin-left: 10px;
}
.foldIcon {
  color: #525f7f;
  float: right;
  width: 20px;
  height: 20px;
  margin-top: 3px;
  cursor: pointer;
}
.navIcon {
  overflow: initial !important;
  visibility: initial !important;
  font-size: 22px;
  vertical-align: text-bottom;
  margin-right: 5px;
}
.el-menu-vertical {
  margin-top: 10px;
  margin-left: 9px;
}
.deleteFav {
  float: right;
  font-size: 22px;
  margin-top: 10px;
}
.FavoriteList {
  max-height: 264px;
  overflow-y: auto;
  -ms-overflow-style: none;
  background-color: #fff !important;
}
.FavoriteList li {
  background-color: #fff !important;
}
.FavoriteList::-webkit-scrollbar {
  width: 0 !important;
}
.time {
  text-align: center;
  margin-top: 20px;
}
.countDown {
  font-size: 20px;
  color: #fff;
  background-color: #413737;
  width: 250px;
  line-height: 40px;
  border-radius: 3px;
  margin: 0 auto;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.3) inset;
}
.el-menu-vertical:not(.el-menu--collapse) {
  width: 290px;
  min-height: 400px;
}
.clockwrap {
  display: inline-block;
  margin: 20px 0 0 6px;
}
.wrap {
  width: 50px;
  height: 50px;
  position: relative;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0px 5px 13px 0px rgba(0, 0, 0, 0.15);
}
.wrap .number {
  position: absolute;
  width: 100%;
  top: 15px;
  font-size: 12px;
  text-align: initial;
  color: rgb(82, 95, 127);
}

.wrap .shot {
  position: absolute;
  left: 50%;
  bottom: 50%;
  /*设置圆心旋转点的位置*/
  transform-origin: 50% bottom;
}
#hour {
  width: 3px;
  height: 11px;
  background-color: rgb(82, 95, 127);
}
#min {
  width: 2px;
  height: 16px;
  background-color: rgb(82, 95, 127);
}
#sec {
  width: 1px;
  height: 20px;
  background-color: red;
}
.ahref {
  display: block;
  text-decoration: none;
  outline: none;
  color: rgb(82, 95, 127);
}
.ahrefNew {
  text-decoration: none;
  outline: none;
  color: rgb(82, 95, 127);
  display: inline-block;
  width: 100%;
}
/* 移动头像和语言切换至左侧菜单区 */
.info {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 0;
}
.info .infoIcon {
  font-size: 22px;
  color: #9ea1b5;
  vertical-align: top;
  margin-right: 8px;
}
.info .langChage {
  display: inline-block;
  vertical-align: middle;
  font-size: 14px;
  margin-top: 15px;
}
.info .langChage span {
  cursor: pointer;
}
.info .langChage .selected {
  color: rgba(103, 113, 229, 1);
  font-weight: bold;
}
.menu {
  border: 1px solid #ccc;
  border-bottom: none;
}
.menu li {
  height: 40px;
  line-height: 40px;
  text-align: center;
  padding: 0 10px;
  cursor: pointer;
  border-bottom: 1px solid #ccc;
}
.hyperlink {
  color: #606266;
  display: inline-block;
  height: 36px !important;
  line-height: 36px !important;
}
.hyperlink:hover {
  color: #66b1ff;
}
canvas {
  border-radius: 20px;
  vertical-align: middle;
  box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.15);
}
.dropdown {
  position: relative !important;
}
.dropdown-menu-right {
  position: absolute !important;
  top: 60px !important;
  left: 160px !important;
}
.dropdown-menu-left {
  position: absolute !important;
  top: 60px !important;
  left: 60px !important;
}
.el-dropdown + .el-dropdown {
  margin-left: 0px;
}
/* 切换工厂弹出框 */
.isActive {
  background: #94afda !important;
}
.selectfactory .loginbox {
  background: #fff;
  /* position: absolute;
  left: 50%;
  top:50%;
  transform: translate(-50%,-50%); */
}
.selectfactory .loginbox .content {
  width: 600px;
  height: 460px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  padding: 20px 50px;
}
.content:after {
  content: '';
  width: 300px;
}

.selectfactory .loginbox .itembox {
  background: #e4e8f1;
  margin-right: 10px;
  width: 120px;
  height: 120px;
  border-radius: 10px;
  padding: 10px 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.selectfactory .loginbox .itembox:nth-child(4n) {
  margin-right: 0;
}
.selectfactory .loginbox .itembox img {
  width: 100%;
}
.selectfactory .loginbox .itembox p {
  width: 100%;
  background: #2254e4;
  text-align: center;
  border-radius: 10px;
  color: #fff;
  font-size: 18px;
  margin-bottom: 5px;
}
.labMenu {
  height: 100%;
}
</style>
